import React from 'react';

const NotFound = () => {
  return (
    <div className="center">
      <h1>404: Page Not Found</h1>
      <br />
      <p>The page you are looking for cannot be found</p>
    </div>
  );
};

export default NotFound;
